var Q = Object.defineProperty, $ = Object.defineProperties;
var K = Object.getOwnPropertyDescriptors;
var F = Object.getOwnPropertySymbols;
var L = Object.prototype.hasOwnProperty, R = Object.prototype.propertyIsEnumerable;
var O = (r, s, n) => s in r ? Q(r, s, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[s] = n, P = (r, s) => {
  for (var n in s || (s = {}))
    L.call(s, n) && O(r, n, s[n]);
  if (F)
    for (var n of F(s))
      R.call(s, n) && O(r, n, s[n]);
  return r;
}, T = (r, s) => $(r, K(s));
var i = (r, s, n) => new Promise((_, l) => {
  var g = (a) => {
    try {
      f(n.next(a));
    } catch (e) {
      l(e);
    }
  }, w = (a) => {
    try {
      f(n.throw(a));
    } catch (e) {
      l(e);
    }
  }, f = (a) => a.done ? _(a.value) : Promise.resolve(a.value).then(g, w);
  f((n = n.apply(r, s)).next());
});
import { u as D, a as I } from "./query-client-DZ5Df1It.js";
import { u as y } from "./useMutation-DFzOBEuf.js";
import { aB as k, r as u, m as S, q as Y } from "./define-element-XpjsV6s1.js";
import { i as d, g as m, e as j, t as q } from "./utils-CMsllPx8.js";
let h = null, p = null, v = null, U = !1, x = !1, B = !1;
function z(r, s) {
  return i(this, null, function* () {
    var _, l;
    const n = (l = (_ = window.OFFSET) == null ? void 0 : _.loginUrl) != null ? l : "";
    if (!d(n))
      try {
        yield fetch(n, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams({
            "auth[username]": r,
            "auth[password]": s
          })
        });
      } catch (g) {
      }
  });
}
function C() {
  const r = D();
  if (x || (x = !0, document.addEventListener("cantina:login", () => {
    r == null || r.invalidateQueries({ queryKey: ["user"] });
  })), h || (h = I({
    queryKey: ["user"],
    queryFn: () => i(null, null, function* () {
      return yield u("get_customer");
    }),
    // request() throws this exact message for a logged-out customer (see
    // packages/core/index.ts) — that's an expected, normal state, not a
    // transient failure, so retrying it 3x (TanStack Query's default)
    // only makes AccountLogin.vue's "Loading..." state hang for no
    // reason. Any other error (network blip, real 5xx) still gets the
    // default up-to-3 retries.
    retry: (e, t) => t instanceof Error && t.message === "Authentication Required" ? !1 : e < 3
  })), !U) {
    U = !0;
    const e = new URLSearchParams(window.location.search), t = e.get("preauth");
    t && (k(), u("cart/auth", {
      method: "POST",
      body: JSON.stringify({ authtoken: t })
    }).then(() => {
      if (r == null || r.invalidateQueries({ queryKey: ["user"] }), !e.get("invoice")) {
        e.delete("preauth");
        const o = e.toString(), c = window.location.pathname + (o ? `?${o}` : "") + window.location.hash;
        window.history.replaceState(null, "", c);
      }
    }));
  }
  p || (p = y({
    mutationFn: (e) => i(null, null, function* () {
      const t = yield u("cart/auth", {
        method: "POST",
        body: JSON.stringify({
          username: e.email,
          password: e.password
        })
      });
      if (t.error)
        throw new Error(
          `We're sorry, but the password for ${e.email} seems to be incorrect. Please try again.`
        );
      return t;
    }),
    onSuccess: (e, t) => {
      r == null || r.invalidateQueries({ queryKey: ["user"] }), z(t.email, t.password);
    }
  })), v || (v = y({
    mutationFn: () => i(null, null, function* () {
      var t, o;
      const e = (o = (t = window.OFFSET) == null ? void 0 : t.logoutUrl) != null ? o : "";
      if (!d(e))
        try {
          yield fetch(e, { method: "GET", credentials: "include" });
        } catch (c) {
        }
      return yield u("logout", {
        method: "POST"
      });
    }),
    onSuccess: () => {
      k(), r == null || r.invalidateQueries({ queryKey: ["user"] });
    }
  }));
  const s = y({
    mutationFn: (e) => i(null, null, function* () {
      const t = yield u("cart/auth/customer", {
        method: "POST",
        body: JSON.stringify({
          active_account: "Yes",
          salutation: e.salutation,
          first_name: e.first_name,
          last_name: e.last_name,
          username: e.email,
          password: e.password,
          state: e.state,
          phone: e.phone,
          mobile_phone: e.mobile_phone,
          birthday: e.birthday,
          receive_text_messages: e.receive_text_messages,
          mail_marketing_opt_in: e.mail_marketing_opt_in,
          mailing_country: e.mailing_country,
          mailing_address: e.mailing_address,
          mailing_address_2: e.mailing_address_2,
          mailing_city: e.mailing_city,
          mailing_state: e.mailing_state,
          mailing_zip: e.mailing_zip,
          referral_source: e.referral_source,
          referral_note: e.referral_note,
          customer_signup_answer: e.customer_signup_answer,
          comments: e.comments,
          marketing_opt_in: e.marketing_opt_in,
          agreed_to_terms_privacy: e.agreed_to_terms_privacy,
          agreed_to_mailing_list: e.agreed_to_mailing_list,
          consent_date: e.consent_date,
          consent_time: e.consent_time,
          consent_token: e.consent_token,
          group_id: e.group_id,
          customer_source: e.customer_source,
          page_source: e.page_source,
          customer_type: e.customer_type
        })
      });
      if (t.error)
        throw new Error(t.error);
      return t;
    }),
    onSuccess: (e, t) => {
      q("CompleteRegistration"), p.mutate({ email: t.email, password: t.password });
    }
  });
  function n(e) {
    return i(this, null, function* () {
      return yield u("cart/auth/send_token", {
        method: "POST",
        body: JSON.stringify({
          username: e
        })
      });
    });
  }
  function _(e) {
    return i(this, null, function* () {
      return yield u(`cart/auth/username/${e}`);
    });
  }
  function l(e) {
    return i(this, null, function* () {
      var o;
      const t = yield u("cart/customer", {
        method: "PUT",
        body: JSON.stringify(e)
      });
      if (t == null || t.error)
        throw new Error((o = t == null ? void 0 : t.error) != null ? o : "Unable to update customer profile");
      return t;
    });
  }
  function g(e) {
    return i(this, null, function* () {
      var o;
      const t = yield u("cart/auth/password", {
        method: "PUT",
        body: JSON.stringify(e)
      });
      if (t == null || t.error)
        throw new Error((o = t == null ? void 0 : t.error) != null ? o : "Unable to update password");
      return t;
    });
  }
  const w = S(() => {
    var e;
    return h.data.value && !d((e = h.data.value) == null ? void 0 : e.id);
  });
  B || (B = !0, Y(
    w,
    (e) => {
      var o;
      const t = !!e;
      typeof window != "undefined" && (window.OFFSET = (o = window.OFFSET) != null ? o : {}, window.OFFSET.isLoggedIn = t), typeof document != "undefined" && document.dispatchEvent(new CustomEvent("offset:authchange", { detail: { loggedIn: t } }));
    },
    { immediate: !0 }
  ));
  const f = S(() => {
    var c, E, b;
    const e = (c = m("offsetBirthDay")) != null ? c : null, t = (E = m("offsetBirthMonth")) != null ? E : null, o = (b = m("offsetBirthYear")) != null ? b : null;
    if (!d(e) && !d(t) && !d(o)) {
      const [J, M, N] = j(
        e,
        t,
        o
      );
      return `${N}-${M}-${J}`;
    }
    return "";
  }), a = S(() => {
    var e, t, o, c;
    return {
      first_name: (e = m("first_name")) != null ? e : "",
      last_name: (t = m("last_name")) != null ? t : "",
      email: (o = m("email")) != null ? o : "",
      phone: (c = m("phone")) != null ? c : "",
      birthday: f.value
    };
  });
  return T(P({}, h), {
    loginMutation: p,
    logoutMutation: v,
    subscribeMutation: s,
    resetPassword: n,
    userExists: _,
    isValidUser: w,
    prefilledData: a,
    updateProfile: l,
    updatePassword: g
  });
}
export {
  C as u
};
